import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue' 
import Faq from './views/FaqAtos.vue' 
import TermsOfUse from './views/TermsOfUse.vue' 

import ListActs from './views/ListActs.vue' 
import DetailActs from './views/DetailActs.vue' 
import store from "@/store"

Vue.use(Router)

export default new Router({
  
  mode: 'history',
  routes:[
    { path: '/'                               , name:'Home'           ,component: Home},
    { path: '/privacypolicy'                  , name:'PrivacyPolicy'  ,component: PrivacyPolicy},
    { path: '/faq'                            , name:'Faq'            ,component: Faq},
    { path: '/termsofuse'                     , name:'TermsOfUse'     ,component: TermsOfUse},
    { path: '/listActs'                       , name:'listActs'       ,component: ListActs},
    { path: '/detailActs/:actType/:actNumber' , name:'DetailActs'     ,component: DetailActs , props: true}
  ],
 })
